import LandingPage, { type LandingPageData } from "./landing";
import { landingContent } from "@shared/landing-content";

const data: LandingPageData = {
  path: "/klaviyo-email-marketing-ecommerce",
  seo: {
    nl: {
      title: "Klaviyo & E-mailmarketing Bureau voor D2C E-commerce | Wrkt Digital",
      description: "Wrkt Digital is gespecialiseerd in Klaviyo, e-mailmarketing en CRM voor D2C e-commerce merken. Flows, segmentatie en retentiestrategieën die je omzet structureel verhogen.",
      keywords: "Klaviyo bureau Nederland, Klaviyo partner Amsterdam, e-mail marketing e-commerce, e-mailmarketing bureau, CRM e-commerce, e-mail marketing bureau Nederland, Klaviyo flows, e-mail automatisering webshop, retentie marketing D2C, Klaviyo agency, lifecycle marketing, customer retention e-commerce, CRM webshop, e-mailmarketing strategie, CRM bureau Amsterdam, e-mailmarketing uitbesteden",
    },
    en: {
      title: "Klaviyo & Email Marketing Agency for D2C E-commerce | Wrkt Digital",
      description: "Wrkt Digital specializes in Klaviyo, email marketing and CRM for D2C e-commerce brands. Flows, segmentation and retention strategies that structurally increase your revenue.",
      keywords: "Klaviyo agency Netherlands, Klaviyo partner Amsterdam, email marketing e-commerce, email marketing agency, CRM e-commerce, email marketing agency Netherlands, Klaviyo flows, email automation webshop, retention marketing D2C, Klaviyo agency, lifecycle marketing, customer retention e-commerce, CRM webshop, email marketing strategy, CRM agency Amsterdam, outsource email marketing",
    },
  },
  content: landingContent["/klaviyo-email-marketing-ecommerce"],
};

export default function LandingKlaviyo() {
  return <LandingPage data={data} />;
}
